export const sortByYear = (array) => {
  return [...array].sort((a, b) => b.acf.year - a.acf.year);
};

export const extractPeopleData = (array) => {
  return array.map((element) => {
    const workAreas = element.acf.workareas !== false 
      ? element.acf.workareas.map((area) => ({ 
          id: area.ID, 
          title: area.post_title 
        })) 
      : [];
    
    const projects = element.acf.related_projects !== false 
      ? element.acf.related_projects.map((area) => ({ 
          id: area.ID, 
          title: area.post_title 
        })) 
      : [];
    
    const publications = element.acf.related_publications !== false 
      ? element.acf.related_publications.map((area) => ({ 
          id: area.ID, 
          title: area.post_title 
        })) 
      : [];

    return {
      ...element,
      acf: {
        ...element.acf,
        workAreas,
        relatedProjects: projects,
        relatedPublications: publications,
      },
    };
  });
};

export const extractProjectWorkAreas = (array) => {
  return array.map((element) => {
    try {
      const workAreas = element.acf.workareas.map((area) => area.post_title);
      return {
        ...element,
        acf: {
          ...element.acf,
          workAreas,
        },
      };
    } catch (error) {
      console.error(`Error retrieving work areas for project ${element.id}:`, error);
      return {
        ...element,
        acf: {
          ...element.acf,
          workAreas: [],
        },
      };
    }
  });
};

export const extractPresAuthor = (array) => {
  return array.map(element => {
    try {
      const postAuthor = element.acf.author.map(el => el.post_title);
      const author = postAuthor.map(author => {
        const authorWords = author.split(" ");
        return authorWords.slice(0, -1).join(" ");
      }).join(", ");

      return {
        ...element,
        acf: {
          ...element.acf,
          author
        }
      };
    } catch (error) {
      console.error(`Error processing author for presentation ${element.id}:`, error);
      return {
        ...element,
        acf: {
          ...element.acf,
          author: ""
        }
      };
    }
  });
}; 